/* global device, getDevice */
/**
 * TOUR USAGE
 * ** The tour is currently under development and will be improved as needed in the future. **
 *
 * 1. Add <div id="js-tour-container" data-tour="[content name]"></div> to the page where the tour will be enabled.
 * 2. Configure the tour steps in content to "./steps-content.js".
 *  - Add an array with our [content-name] (same as data-tour attribute) which will contain different steps.
 * 3. For each step, add an object to your [content-name] array:
 *  - Set the [message] with the translation key
 *  - Set the selector for the step. You have to add a selector for desktop [selector] and for mobile [selectorMobile].
 *    If no selector is declared, the message will be centered on the screen.
 *  - Set the position of the step message ('top', 'bottom', 'center).
 *    The position could be different in desktop and mobile,
 *  so you can add a [position] for desktop and a [positionMobile] for mobile.
 * 4. Map the corresponding translations in "./messages.js" and "translations/[LANG].json"
 *
 *  TODO:
 *  - Enable more positions for steps ('left' and 'right') if needed
 */

import React, { Component } from "react";
import { injectIntl } from "react-intl";
import { debounce } from "../../utils/helpers";
import TourStep from "./../../components/Tour/tour-step";
import STEPS_CONTENT from "./steps-content";
const loadingLogo = "https://assets.adsttc.com/doodles/flat/loader-blue.gif";

class Tour extends Component {
  constructor (props) {
    super(props);
    this.state = {
      tourIsActive: true,
      tourContent: STEPS_CONTENT[props.tourType],
      currentStep: 1,
      totalSteps: STEPS_CONTENT[props.tourType].length,
      isMobile: device !== "desktop",
      userInfoLoaded: false
    };
  }

  getActiveItemPosition (selector) {
    if (!selector) { return {}; }
    const activeItem = document.querySelector(selector);
    activeItem && activeItem.scrollIntoView({ block: "center" });
    const { top, left, width, height } = activeItem && activeItem.getBoundingClientRect();
    return { top, left, width, height };
  }

  stepMovementHandler (movement) {
    if ((movement === "prev" && this.state.currentStep <= 1) ||
      (movement === "next" && this.state.currentStep >= this.state.totalSteps)) { return false; }
    this.setState(prevState => ({
      currentStep: movement === "prev" ? prevState.currentStep - 1 : prevState.currentStep + 1
    }));
  }

  filterValidSteps () {
    return STEPS_CONTENT[this.props.tourType]
      .filter(step => (this.state.isMobile && step.selectorMobile) || (!this.state.isMobile && step.selector));
  }

  onWindowResize () {
    const filteredSteps = this.filterValidSteps();
    getDevice();
    this.setState({
      isMobile: device !== "desktop",
      tourContent: filteredSteps,
      totalSteps: filteredSteps.length
    });
  }

  closeHandler () {
    this.setState({
      tourIsActive: false
    });
    document.getElementsByTagName("body")[0].classList.remove("no-scroll");
    window.removeEventListener("resize", debounce(this.onWindowResize, 300));
  }

  removeLoader () {
    this.setState({ userInfoLoaded: true });
  }

  componentDidMount () {
    const filteredSteps = this.filterValidSteps();
    window.addEventListener("resize", this.onWindowResize);
    document.getElementsByTagName("body")[0].classList.add("no-scroll");
    this.setState({
      tourContent: filteredSteps,
      totalSteps: filteredSteps.length
    });
    MyAD.userLoaded ? this.removeLoader() : document.addEventListener("myad:user-loaded", this.removeLoader);
  }

  render () {
    if (this.state.tourIsActive && this.state.totalSteps) {
      const { currentStep, totalSteps, isMobile, tourContent, userInfoLoaded } = this.state;

      const activeStep = tourContent[currentStep - 1];
      const activeItemPosition = userInfoLoaded
        ? this.getActiveItemPosition(isMobile ? activeStep.selectorMobile : activeStep.selector)
        : { width: 0, height: 0 };
      return (
        <div className="myad-tour-container">
          <div className="myad-tour-highlight" style={activeItemPosition} />
          {userInfoLoaded
            ? <TourStep
                targetItemPosition={activeItemPosition}
                translatedMessage={this.props.intl.formatMessage(activeStep.message)}
                isFirst={currentStep === 1}
                isLast={currentStep === totalSteps}
                onPrevStep={() => this.stepMovementHandler("prev")}
                onNextStep={() => this.stepMovementHandler("next")}
                onClose={() => this.closeHandler()}
                textPosition={!this.state.isMobile ? activeStep.position : activeStep.positionMobile}
                isMobile={this.state.isMobile}
              />
            : <img src={loadingLogo} alt="logo" className="myad-tour-loading" />}
        </div>
      );
    }
    return null;
  }
}

export default injectIntl(Tour);
